export const DEFAULT_ERR = 'Something went Wrong';
export const FALCON_THEME = 'FALCON_THEME';
export const FALCON_USER = 'FALCON_USER';

// THEME ACTION TYPES
export const SET_THEME_REQUEST = 'SET_THEME_REQUEST';
export const SET_THEME_SUCCESS = 'SET_THEME_SUCCESS';
export const SET_THEME_FAILED = 'SET_THEME_FAILED';

export const GET_THEME_REQUEST = 'GET_THEME_REQUEST';
export const GET_THEME_SUCCESS = 'GET_THEME_SUCCESS';
export const GET_THEME_FAILED = 'GET_THEME_FAILED';

// Alert
export const SET_ALERT = 'SET_ALERT';
export const REMOVE_ALERT = 'REMOVE_ALERT';

// Analytics
export const GET_ANALYTICS_REQUEST = 'GET_ANALYTICS_REQUEST';
export const GET_ANALYTICS_SUCCESS = 'GET_ANALYTICS_SUCCESS';
export const GET_ANALYTICS_FAILED = 'GET_ANALYTICS_FAILED';

export const GET_PERFORMANCE_REQUEST = 'GET_PERFORMANCE_REQUEST';
export const GET_PERFORMANCE_SUCCESS = 'GET_PERFORMANCE_SUCCESS';
export const GET_PERFORMANCE_FAILED = 'GET_PERFORMANCE_FAILED';

export const GET_SALES_REQUEST = 'GET_SALES_REQUEST';
export const GET_SALES_SUCCESS = 'GET_SALES_SUCCESS';
export const GET_SALES_FAILED = 'GET_SALES_FAILED';

export const GET_ORDERCOUNT_REQUEST = 'GET_ORDERCOUNT_REQUEST';
export const GET_ORDERCOUNT_SUCCESS = 'GET_ORDERCOUNT_SUCCESS';
export const GET_ORDERCOUNT_FAILED = 'GET_ORDERCOUNT_FAILED';

// Seller Tiering
export const GET_TIERING_REQUEST = 'GET_TIERING_REQUEST';
export const GET_TIERING_SUCCESS = 'GET_TIERING_SUCCESS';
export const GET_TIERING_FAILED = 'GET_TIERING_FAILED';

// Notification
export const GET_NOTIFICATION_COUNT_REQUEST = 'GET_NOTIFICATION_COUNT_REQUEST';
export const GET_NOTIFICATION_COUNT_SUCCESS = 'GET_NOTIFICATION_COUNT_SUCCESS';
export const GET_NOTIFICATION_COUNT_FAILED = 'GET_NOTIFICATION_COUNT_FAILED';

export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST';
export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
export const GET_NOTIFICATIONS_FAILED = 'GET_NOTIFICATIONS_FAILED';

export const READ_NOTIFICATIONS_REQUEST = 'READ_NOTIFICATIONS_REQUEST';
export const READ_NOTIFICATIONS_SUCCESS = 'READ_NOTIFICATIONS_SUCCESS';
export const READ_NOTIFICATIONS_FAILED = 'READ_NOTIFICATIONS_FAILED';

//Banner
export const GET_BANNER_REQUEST = 'GET_BANNER_REQUEST';
export const GET_BANNER_SUCCESS = 'GET_BANNER_SUCCESS';
export const GET_BANNER_FAILED = 'GET_BANNER_FAILED';

// API Credentials
export const GET_API_CREDENTIAL_REQUEST = 'GET_API_CREDENTIAL_REQUEST';
export const GET_API_CREDENTIAL_SUCCESS = 'GET_API_CREDENTIAL_SUCCESS';
export const GET_API_CREDENTIAL_FAILED = 'GET_API_CREDENTIAL_FAILED';

// GET APOB SELLERS
export const GET_APOB_SELLER_REQUEST = 'GET_APOB_SELLER_REQUEST';
export const GET_APOB_SELLER_SUCCESS = 'GET_APOB_SELLER_SUCCESS';
export const GET_APOB_SELLER_FAILED = 'GET_APOB_SELLER_FAILED';

//SELECT CHILD APOB SELLER
export const SET_SELECT_APOB_SELLER = 'SET_SELECT_APOB_SELLER';
